<template>
	<div class="memberLog layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				注册资料
			</div>
		</div>
		<div class="layui-form px16" action="">
			<table class="layui-table bge" style="width:48%;margin: 50px 0 50px 26%;">
				<colgroup>
					<col width="25%">
					<col width="25%">
					<col width="25%">
					<col width="25%">
				</colgroup>
				<tbody class="align_center px16">
					<tr>
						<td class="ft_wt">姓名</td>
						<td>{{infos.name}}</td>
						<td class="ft_wt">性别</td>
						<td>{{infos.sex == 1 ? '男' : '女'}}</td>
					</tr>
					<tr>
						<td class="ft_wt">出生年月</td>
						<td>{{infos.birthday}}</td>
						<td class="ft_wt">民族</td>
						<td>{{infos.nation}}族</td>
					</tr>
					<tr>
						<td class="ft_wt">联系电话</td>
						<td>{{infos.mobile}}</td>
						<td class="ft_wt">从业年限</td>
						<td>{{infos.work_life}}年</td>
					</tr>
					<tr>
						<td class="ft_wt">合作意向</td>
						<td>{{infos.work_type == 1 ? '全职' : '兼职'}}</td>
						<td class="ft_wt">QQ</td>
						<td>{{infos.qq}}</td>
					</tr>
					<tr>
						<td class="ft_wt">银行卡号</td>
						<td colspan="3">{{infos.bank_card}}</td>
					</tr>
					<tr>
						<td class="ft_wt">联系地址</td>
						<td colspan="3">{{infos.contact_address}}</td>
					</tr>
					<tr>
						<td class="ft_wt">工作邮箱</td>
						<td>{{infos.email}}</td>
						<td class="ft_wt">现所在地</td>
						<td>{{infos.now_address}}</td>
					</tr>
					<tr>
						<td class="ft_wt" colspan="4">工作经历</td>
					</tr>
					<tr>
						<td class="ft_wt">职位</td>
						<td class="ft_wt">就职公司</td>
						<td class="ft_wt">入职时间</td>
						<td class="ft_wt">离职时间</td>
					</tr>
					<tr v-for="(item,i) in infos.work_info" :key="i">
						<td>{{item.position}}</td>
						<td>{{item.company}}</td>
						<td>{{item.in_time}}</td>
						<td>{{item.out_time}}</td>
					</tr>
					<tr>
						<td class="ft_wt">自我介绍</td>
						<td colspan="3" style="height:80px;">{{infos.about_mine}}</td>
					</tr>
				</tbody>
			</table>
			<div class="hint">您的信息如需变更，请及时联系我们平台工作人员进行修改，谢谢。</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'memberLog',
		data() {
			return {
				infos: ''
			}
		},
		created() {

		},
		mounted() {
			let _this = this;
			layui.use(['layer', 'table'], function() {
				var table = layui.table;
				api.getMemberInfo({ //获取会员信息
					token: _this.getCookie('token')
				}).then((res) => {
					if(res.code == 1) {
						res.data.work_info = JSON.parse(res.data.work_info);
						_this.infos = res.data;
					} else if(res.code == 0) {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				});
			});
		},
		methods: {

		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.memberLog {
		font-family: SourceHanSansSC;
	}
	
	.bge td {
		line-height: 45px;
		min-height: 45px;
		height: 45px;
		padding: 0;
		border-width: 1px;
		border-color: #000;
		position: inherit;
	}
	
	.bge input {
		width: 100%;
		text-align: center;
		display: block;
		height: 45px;
		border: none;
	}
	
	.hint {
		text-align: center;
		color: #FF0000;
		margin: 50px 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/registerMsg.vue